/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Defectburner1Inputs */



/**
* | output |
* | --- |
* | "Burner defect" |
*
* @param {Br_History_Key_Defectburner1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_defectburner1 = /** @type {((inputs?: Br_History_Key_Defectburner1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Defectburner1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Burner defect")
	return /** @type {LocalizedString} */ ("Défaut du brûleur")
});
export { br_history_key_defectburner1 as "br_history_key_defectBurner" }